import { IJsonQuery } from '@cian/api-models/common/json_query';
import { IGeoSuggestResponseScheme } from '@cian/api-models/suggest/v2/suggest';

import { dealTypeFromJsonQuery, offerTypeFromJsonQuery, FOfferType, FDealType } from '../utils/category';
import { IMakeRequest } from '../../app/helpers/network_helper';

export interface IGetGeoSuggestionsParameters {
  jsonQuery: IJsonQuery;
  regionId: number;
  query: string;
}

export function getGeoSuggestions(
  makeRequest: IMakeRequest,
  parameters: IGetGeoSuggestionsParameters,
): Promise<IGeoSuggestResponseScheme> {
  return makeRequest({
    method: 'GET',
    uri: {
      // Костыль :<
      host: window.__mainpage_geo_suggest_api_base_url__,
      path: '/v1/suggest/',
      query: getGeoSuggestionsQuery(parameters),
    },
  });
}

export function getGeoSuggestionsQuery(parameters: IGetGeoSuggestionsParameters): string {
  const { jsonQuery, regionId, query } = parameters;
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  const queryDealType = mapDealType(dealType);
  const queryOfferType = mapOfferType(offerType);

  return [
    queryDealType && `dealType=${queryDealType}`,
    queryOfferType && `offerType=${queryOfferType}`,
    `regionId=${regionId}`,
    `query=${query}`,
    'source=mainpage',
  ].filter(Boolean).join('&');
}

export function mapDealType(dealType: FDealType): string | null {
  switch (true) {
    case (dealType & FDealType.Sale) !== 0:
      return 'sale';

    case (dealType & FDealType.Rent) !== 0:
      return 'rent';
  }

  return null;
}

export function mapOfferType(offerType: FOfferType): string | null {
  switch (true) {
    case offerType === FOfferType.FlatNew:
      return 'newobject';

    case (offerType & FOfferType.Flat) !== 0:
      return 'flat';

    case (offerType & FOfferType.Suburban) !== 0:
      return 'suburban';

    case (offerType & FOfferType.Commercial) !== 0:
      return 'commercial';
  }

  return null;
}
